import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { Alert } from '@mui/material';
import { type } from '@testing-library/user-event/dist/type';
import { apiPath2 } from "../src/services/apiConfig";

function Visitors() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  // const [displayDepartment, setDisplayDepartment] = useState('none');
  const [displayUpdDepartment, setDisplayUpdDepartment] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [departmentName, setDepartmentName] = useState('');
  // const [uid, setUID] = useState('');
  // const [specialityType, setSpecialityType] = useState('1');
  const [verfied, setVerfied] = useState(true);
  const [updDepartmentName, setDepartmentUpdName] = useState('');
  const [id, setID] = useState('');
  //  const [uidErr, setUIDErr] = useState('');
  //  const [Err, SetErr] = useState([]);
  const [mobileNo, setMobileNo] = useState()
  const [FromDt, setFromDt] = useState()
  const [ToDt, setToDt] = useState()
  const [displayMobileSearch, setDisplayMobileSearch] = useState('none');
  const [displayDateSearch, setDisplayDateSearch] = useState('none');

  let txt = "";
  useEffect(() => {
    getVisitor()
  }, [])

  {/*
  function openDepartment() {
    setDisplayDepartment('block')
  }

  function closeDepartment() {
    setDisplayDepartment('none')
  }
*/}

  function openUpdDepartment() {
    setDisplayUpdDepartment('block')
  }

  function closeUpdUser() {
    setDisplayUpdDepartment('none')
  }

  async function updateDepartment(id) {
    //alert(id+','+updSpecialityName+","+updSpecialityType)

    let result = await fetch(apiPath2 + "departments/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "name": updDepartmentName
      })
    });

    result = await result.json();

    showSwal(result.success, result.message)

    getVisitor()

  }

  async function deleteDepartment(id) {

    let result = await fetch(apiPath2 + "departments/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getVisitor()
  }



  async function updateOperation(id) {

    let result = await fetch(apiPath2 + "departments/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",

          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },

      });

    result = await result.json();

    console.warn(result.data)

    setDepartmentUpdName(result.data.name);
    setID(result.data.id)

    openUpdDepartment();
  }


  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDepartment(id);
        }
        else {
          swal("Your record is safe!");
        }

      });
  }

  //* LIST OF ALL DEPARTMENT (for initial screen)*/ 

  async function getVisitor() {

    let result = await fetch(apiPath2 + "visitors",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  //* LIST OF ALL DEPARTMENT (for initial screen)*/ 

  async function getVisitorByMobile(mobileNo) {

    alert(mobileNo)
    let result = await fetch(apiPath2 + "visitorsByMobile/" + mobileNo,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
//      setUID(item)
    }
  }
*/}

  function verifyDepartment() {
    setVerfied(true)
    addDepartment()
  }

  //*ADD A NEW DEPARTMENT*/ 
  async function addDepartment() {
    //    alert('Add,'+departmentName)
    if (verfied) {

      let result = await fetch(apiPath2 + "departments", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": departmentName,
        })

      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getVisitor()
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  function searchVisitor(e) {
    // alert(e.target.value)
    if (e.target.value === '0') {

      getVisitor()
    }
    if (e.target.value === '1') {
      setDisplayMobileSearch('block')
    }
    if (e.target.value === '2') {
      setDisplayDateSearch('block')
    }
  }

  function searchByMobile() {
    // alert(mobileNo)
    getVisitorByMobile(mobileNo)
    closeMobileSearch()
  }

  function searchByDate() {
    closeDateSearch()
  }

  function closeMobileSearch() {
    setDisplayMobileSearch('none')
  }

  function closeDateSearch() {
    setDisplayDateSearch('none')
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>

          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Visitors Management</h4>
            </div>
            <div className="c12-l-7"></div>

            <div className="c12-l-2 px4">
              <select className="custom-select" onChange={searchVisitor} >
                <option value="0" >All Visitors</option>
                <option value="1" >Visitor by Mobile Number</option>
                <option value="2" >Visitor by Date</option>
              </select>
            </div>
          </div>

          <div className="row mt16" >

            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="10%">Id</th>
                  <th className="th-border left" width="15%">Name</th>
                  <th className="th-border left" width="15%">Mobile</th>
                  <th className="th-border left" width="25%">Requirement</th>
                  <th className="th-border left" width="55%">From URL</th>
                  <th className="th-border left" width="25%">Date visited</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.name}</td>
                          <td className="left">{item.mobile}</td>
                          <td className="left">{item.requirement}</td>
                          <td className="left">{item.from_url}</td>
                          <td className="left">{item.created_at.toString('yyyy-MM-dd')}</td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM SEARCH BY MOBILE */}

          <div id="newdept" style={{ 'display': displayMobileSearch, 'height': '25vh' }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeMobileSearch}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
                <div className="c12-l-12">
                  <h5>Search By Mobile</h5>

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Mobile Number" onChange={(e) => setMobileNo(e.target.value)} />

                  <button onClick={searchByMobile} type="button"
                    className="btn solid round">Search</button>

                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM SEARCH BY DATE */}

          <div id="newdept" style={{ 'display': displayDateSearch, 'height': '30vh' }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeDateSearch}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
                <div className="c12-l-12">
                  <h5>Search By Date</h5>

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="From Date" onChange={(e) => setFromDt(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="To Date" onChange={(e) => setToDt(e.target.value)} />

                  <button onClick={searchByDate} type="button"
                    className="btn solid round">Search</button>

                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdDepartment }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Department</h2><br /><br />

                  <input type="hidden" value={id} />

                  <input type="text" className="box small"
                    placeholder="Name of the Department" onChange={(e) => setDepartmentUpdName(e.target.value)}
                    value={updDepartmentName} />

                  <br></br>
                  <button onClick={() => { updateDepartment(id) }} type="button"
                    className="btn solid round">Update Department</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Visitors;
